export enum StockStatus {
    InStock = 'InStock',
    FewLeftInStock = 'FewLeftInStock',
    OutOfStock = 'OutOfStock',
    NotAvailable = 'NotAvailableInYourArea',
}
